
import { faArrowAltCircleUp } from "@fortawesome/free-regular-svg-icons/faArrowAltCircleUp";
import { faSquareCheck } from "@fortawesome/free-regular-svg-icons/faSquareCheck";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faClipboard } from "@fortawesome/free-solid-svg-icons/faClipboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import React, { memo, useState } from "react";
const estilosBarraFerramentasGrid =
  require("./barra-ferramentas-grid.module.scss").default;
const estilosBotoes = require("../../../../estilos/botoes.module.scss").default;

export type BarraFerramentasGridProps = {
  pesquisandoApenasParaFiltroProdutosLupa?: boolean // 470698
  desativarBotaoComparar: boolean;
  desativarBotaoAcoes: boolean;
  habiliarAcoesGrid: boolean
  ocultarBotaoComparar?: boolean // 440721
  somenteIncluir: boolean
  mostrarBotaoInserirContinuar: boolean
  processandoProduto: boolean
  onOk: () => void;
  onInserirContinuar: () => void;
  onSelecionarTodos: () => void;
  onInserirNovo: () => void;
  onIncrementarQuantidade: () => void;
  onComparar: () => void;
};

export const BarraFerramentasGrid = memo((props: BarraFerramentasGridProps) => {
  const [expandirDropDown, setExpandirDropDown] = useState(false);

  return (
    <div
      className={`_flex _flex-row _w-full ${estilosBarraFerramentasGrid.barraFerramentasGrid}`}
    >

      {props.habiliarAcoesGrid && (
        <>
          <button
            className={estilosBarraFerramentasGrid.backgroundButton}
            onClick={() => props.onOk()}
            id="BarraFerramentasGrid_botaoOk"
            disabled={props.processandoProduto}
          >
            Ok
          </button>
          {props.mostrarBotaoInserirContinuar && <button
            className={estilosBarraFerramentasGrid.backgroundButton}
            onClick={() => props.onInserirContinuar()}
            id="BarraFerramentasGrid_botaoInserirEContinuar"
            title="Insere produtos selecionados no orçamento e continua na pesquisa de produtos - Tecla Atalho [9]"
            disabled={props.processandoProduto}
            accessKey="9"
          >
            Inserir e Continuar
          </button>}

        </>
      )}

      {props.somenteIncluir && (
        <>
          <button
            className={`${estilosBotoes.botaoIcone} no-global-button`}
            onClick={() => props.onSelecionarTodos()}
            id="BarraFerramentasGrid_botaoSelecionarTodos"
            disabled={props.processandoProduto}
          >
            <FontAwesomeIcon icon={faSquareCheck} />
            Selecionar todos
          </button>

          {props.habiliarAcoesGrid && !props.ocultarBotaoComparar && !props.pesquisandoApenasParaFiltroProdutosLupa &&  (

            <div className="_relative">
              <button
                className={`${estilosBotoes.botaoIcone} no-global-button`}
                disabled={props.desativarBotaoAcoes || props.processandoProduto}
                onClick={() => setExpandirDropDown(!expandirDropDown)}
                id="BarraFerramentasGrid_botaoAcoes"
              >
                <FontAwesomeIcon icon={faClipboard} />
                Ações
              </button>
              {expandirDropDown && (
                <ul
                  className="_absolute _-bottom-30 _left-0 _bg-white"
                  onMouseLeave={() => setExpandirDropDown(false)}
                >
                  <li
                    className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentasGrid.sombraBotao)}
                    onClick={() => { props.onInserirNovo(); setExpandirDropDown(false) }}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon
                      icon={faCirclePlus}
                      color="#409fff"
                      title="Inserir Novo"
                    />
                    Inserir Novo
                  </li>
                  <li
                    className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentasGrid.sombraBotao)}
                    onClick={() => { props.onIncrementarQuantidade(); setExpandirDropDown(false) }}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon
                      icon={faArrowAltCircleUp}
                      color="#409fff"
                      title="Incrementar Quantidade"
                    />
                    Incrementar Quantidade
                  </li>
                </ul>
              )}
            </div>
          )}
          {!props.ocultarBotaoComparar &&  // 440721
          <button
            onClick={() => props.onComparar()}
            id="BarraFerramentasGrid_botaoComparar"
            className={`${estilosBotoes.botaoIcone} ${estilosBarraFerramentasGrid.botaoComparar} no-global-button`}
            disabled={props.desativarBotaoComparar || props.processandoProduto}
          >
            Comparar
          </button>
          }
        </>)}

    </div >
  );
})
